module.exports = __webpack_public_path__ + "static/media/capsule.7051f9cf.svg";